import * as React from 'react';
import { clsx } from 'clsx';
import { isSameMonth, isSameDay, isAfter, isBefore, startOfMonth, startOfDay } from 'date-fns';
import { format } from '../../../../../internal/utils/date';
import { generateDataTestId } from '../../../../../internal/utils';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const WEEK_DAYS_ARRAY = [1, 2, 3, 4, 5, 6, 0];
export function DayPicker(props) {
  const {
    selected,
    onChange,
    month,
    dataTestId
  } = props;
  const now = new Date();
  const min = props.min && startOfDay(props.min);
  const max = props.max && startOfDay(props.max);
  const disabledDates = props.disabledDates ? props.disabledDates.reduce((acc, day) => {
    if (day) {
      acc.push(Number(startOfDay(day)));
    }
    return acc;
  }, []) : [];
  const currentMonth = React.useMemo(() => {
    if (min && isBefore(month, min)) {
      return min;
    }
    if (max && isAfter(month, max)) {
      return max;
    }
    return month;
  }, [month, min, max]);
  const dates = React.useMemo(() => {
    const acc = [];
    const nextDate = startOfMonth(currentMonth);
    const day = nextDate.getDay();
    const prevMonthDays = WEEK_DAYS_ARRAY.indexOf(day);
    nextDate.setDate(nextDate.getDate() - prevMonthDays);

    // Цикл на 6 недель, для того чтобы всегда было равное количество недель
    for (let i = 0; i < 7 * 6; i++) {
      acc.push(new Date(nextDate));
      nextDate.setDate(nextDate.getDate() + 1);
    }
    return acc;
  }, [currentMonth]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['week-days'],
      children: dates.slice(0, 7).map((date, i) => {
        const dateFormatted = format('EEEEEE', date);
        return /*#__PURE__*/_jsx("div", {
          className: styles['week-day'],
          "aria-hidden": "true",
          "data-testid": generateDataTestId(dataTestId, [dateFormatted]),
          children: dateFormatted
        }, i);
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['dates'],
      children: dates.map((date, i) => {
        const n = date.getDate();
        return /*#__PURE__*/_jsx("button", {
          className: clsx(styles['date'], selected && isSameDay(date, selected) && styles['selected'], isSameDay(date, now) && styles['today'], !isSameMonth(date, currentMonth) && styles['other-month']),
          onClick: () => {
            onChange(new Date(date));
          },
          "aria-label": format('P', date),
          disabled: isDisabled(date, min, max, disabledDates),
          "data-testid": generateDataTestId(dataTestId, ["".concat(n)]),
          children: n
        }, i);
      })
    })]
  });
}
function isDisabled(date, min, max, disabledDates) {
  return !!(min && isBefore(date, min) || max && isAfter(date, max) || disabledDates && disabledDates.includes(Number(date)));
}